import { bookingRoutes } from '@/Booking/booking.routes';
const bookingModule = {
    routes: bookingRoutes
};
export default bookingModule;
